import { createHttpEndpoint } from '../../utils'

/**
 * Update Client shipping or billing address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/shipping-address/operation/postClientAddresse}
 */
export const postAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'postClientAddress',
  path: '/bm/client/address',
  transformRequestToSnakeCase: true,
})

/**
 * Retrieve Client shipping address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/shipping-address/operation/retrieveClientShippingAddress}
 */
export const getShippingAddress = createHttpEndpoint({
  method: 'GET',
  operationId: 'retrieveClientShippingAddress',
  path: '/bm/client/addresses/shipping',
})

/**
 * Create Client shipping address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/after-sale-client-api/definition#tag/shipping-address/operation/createClientShippingAddress}
 */
export const setShippingAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'createClientShippingAddress',
  path: '/bm/client/addresses/shipping',
})
